import { render } from "./Edit.vue?vue&type=template&id=48fb62fc"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jaimevalencia/Documents/PROYECTOS/SERVIDOR_GIT/soporte_bis/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__